import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {useHistory} from "react-router-dom";
import Button from "../../../components/button";
import Modal from "../../../components/modal";
import LoadingSpinner from '../../../components/loading-spinner';

import {
    clear_maintenance_survey,
    createMaintenanceSurvey,
    CREATE_MAINTENANCE_SURVEY,
    getAllMaintenanceSurvey,
} from "../../../redux/maintenance_survey";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import TextArea from "../../../components/text-area";

const MaintenanceSurvey = (props) => {
    let history = useHistory();
    let dispatch = useDispatch();

    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _get_all_maintenance_survey = useSelector((state) => state.maintenance_survey_module._get_all_maintenance_survey);
    const _create_maintenance_survey = useSelector((state) => state.maintenance_survey_module._create_maintenance_survey);
    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllMaintenanceSurvey(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (_get_all_maintenance_survey && _get_all_maintenance_survey.data && _get_all_maintenance_survey.data.datos) {
            setData(_get_all_maintenance_survey.data.datos);
        }
    }, [_get_all_maintenance_survey]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [modal, setModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [id, setId] = useState(0);

    const [form, setForm] = useState({
        descripcion: "",
        activo: true,
    });

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);

    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'change_maintenancesurvey').length > 0) {
                act.push({
                    name: "edit",
                    label: "Edit",
                    icon: "bx bx-edit",
                    color: "calendar",
                    onClick: (item) => {
                        setModal(true);
                        setId(item.id);
                        history.push(`/encuesta-mantenimiento/editar/${item.id}`);
                    },
                })
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);

    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    useEffect(() => {
        if (_create_maintenance_survey.status === 201) {
            toast.success("Creado correctamente", {position: toast.POSITION.TOP_RIGHT});
            dispatch(clear_maintenance_survey(CREATE_MAINTENANCE_SURVEY));
            dispatch(getAllMaintenanceSurvey(token));
            let id_survey = _create_maintenance_survey.data.datos[0].id;
            history.push(`/encuesta-mantenimiento/editar/${id_survey}`);
            setIsLoading(false);
            setModal(false);
        } else if (_create_maintenance_survey.status !== 0) {
            dispatch(clear_maintenance_survey(CREATE_MAINTENANCE_SURVEY));
            toast.error(_create_maintenance_survey.message, {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
        }
    }, [_create_maintenance_survey, dispatch, history, token, id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (form.descripcion === "") {
            toast.error("Debe ingresar la descripción", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(createMaintenanceSurvey(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Lista"
                            items={[{label: "Encuestas de mantenimientos", link: "/tipos-mantenimientos"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div><ToastContainer/></div>
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                {
                                    permisos.filter(x => x.codigo === 'add_maintenancesurvey').length > 0 ?
                                        <Button type="button" text="Crear" theme="btn btn-success" onClick={() => {
                                            setModal(true);
                                            setForm({...form, descripcion: ''});
                                            setId(0);
                                        }}/> : null
                                }
                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "fecha_creacion",
                                                label: "Fecha de creación",
                                                type: "text",
                                            },
                                            {
                                                name: "descripcion",
                                                label: "Pregunta",
                                                type: "text",
                                            },
                                            {
                                                name: "activo",
                                                label: "Activo",
                                                type: "boolean",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main div-modal" show={modal}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Encuesta de mantenimiento</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <TextArea
                                    id="descripcion"
                                    name="descripcion"
                                    label="Pregunta"
                                    placeholder=""
                                    onChange={handleChange}
                                    rows={4}
                                    value={form.descripcion}
                                />
                            </div>
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModal(false);
                                    setForm({
                                        descripcion: "",
                                        activo: true,
                                        id: id,
                                    })
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Guardar" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default MaintenanceSurvey;
